export default __webpack_public_path__ + "static/media/strikepay_Mark_RGB_Black.ef760265.png";